module.exports = __webpack_public_path__ + "img/icon-switch-on.fb817ba.svg";